export const SET_ISSHOPOPEN = 'SET_ISSHOPOPEN'
export const SET_OPENING_HOURS = 'SET_OPENING_HOURS'
export const SET_TENANT_DETAILS = 'SET_TENANT_DETAILS'
export const SESSION_ISSHOPOPEN = 'openinghours/isOpen'
export const SESSION_OPENINGHOURS = 'openinghours/openingHours'



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/types.js